const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, meta = {}) {
  try {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
}
